import React from 'react';
import Div from '@jumbo/shared/Div';
import Link from '@mui/material/Link';
import { ASSET_IMAGES } from '../../utils/constants/paths';

const Logo = ({ mini, mode, sx }) => {
  return (
    <Div sx={{ display: 'inline-flex', ...sx }}>
      <Link href={'/'}>
        {!mini ? (
          <img
            style={{ width: '135px' }}
            src={
              mode === 'light'
                ? `${ASSET_IMAGES}/tsm-logo-2.png`
                : `${ASSET_IMAGES}/tsm-logo-2.png`
            }
            alt="Jumbo React"
          />
        ) : (
          <img
            style={{ width: '135px' }}
            src={
              mode === 'light'
                ? `${ASSET_IMAGES}/tsm-logo-2.png`
                : `${ASSET_IMAGES}/tsm-logo-2.png`
            }
            alt="Jumbo React"
          />
        )}
      </Link>
    </Div>
  );
};

Logo.defaultProps = {
  mode: 'light',
};

export default Logo;
